exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".csv-import{-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:1rem;padding:1rem;background-color:#fdf6e0;border:1px solid #ffecbf;border-radius:2px}.csv-import,.csv-import-input-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.csv-import-input-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:start;gap:.5rem;-webkit-box-flex:1;-ms-flex:1;flex:1}.csv-import-help{margin:0;font-size:.875rem;color:#2f2b20}.csv-import input[type=file]{-webkit-box-flex:1;-ms-flex:1;flex:1;font-weight:700}.csv-import .btn{background-color:#d3b865;border:1px solid #af984d;color:#2f2b20}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ebbaded","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/office/CsvImport.vue
// module id = sbwD
// module chunks = 0